(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["number-counter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.number-counter-value');
    const updateCounter = (counter) => {
      const target = +counter.getAttribute('data-value');
      counter.innerText = '0';
      const increment = target / 200;

      const countUp = () => {
        const current = +counter.innerText;
        if (current < target) {
          counter.innerText = Math.ceil(current + increment);
          setTimeout(countUp, 5);
        } else {
          counter.innerText = target;
        }
      };

      countUp();
    };
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          updateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    counters.forEach((counter) => {
      observer.observe(counter);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // ─── Helpers ────────────────────────────────────────────────────────────────

    /** Returns the currently visible quantity input for a row (desktop or mobile). */
    function getVisibleQtyInput(row) {
      const inputs = row.querySelectorAll('[data-quick-order-quantity]');
      for (const input of inputs) {
        if (input.offsetParent !== null) return input;
      }
      return inputs[0] || null;
    }

    /** Syncs all qty inputs in a row to the same value. */
    function syncQtyInputs(row, value) {
      row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
        input.value = value;
      });
    }

    /** Updates availability state of a row (checkbox + all qty inputs). */
    function setRowAvailability(row, available) {
      row.dataset.quickOrderRowAvailable = String(available);

      const checkbox = row.querySelector('[data-quick-order-checkbox]');
      row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
        input.disabled = !available;
        if (!available) input.value = '1';
      });

      if (checkbox) {
        checkbox.disabled = !available;
        if (!available) checkbox.checked = false;
      }
    }

    function setSubmitState(form) {
      const btn = form.querySelector('[data-quick-order-submit]');
      if (!btn) return;
      const hasChecked = !!form.querySelector('[data-quick-order-checkbox]:checked');
      btn.disabled = !hasChecked;
      btn.style.cursor = hasChecked ? '' : 'not-allowed';
      btn.style.opacity = hasChecked ? '' : '0.5';
    }

    /** Rebuilds the "N items selected (qty)" summary line. */
    function updateSummary(form) {
      const summary = form.querySelector('[data-quick-order-summary]');
      if (!summary) return;

      let totalProducts = 0;
      let totalQty = 0;

      form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
        const checkbox = row.querySelector('[data-quick-order-checkbox]');
        const input = getVisibleQtyInput(row);
        if (!checkbox?.checked || !input) return;
        totalProducts++;
        totalQty += parseInt(input.value, 10) || 0;
      });

      const label =
        totalProducts === 1
          ? form.dataset.product
          : form.dataset.products;

      const next = `${totalProducts} ${label} ${form.dataset.selected} (${totalQty} ${form.dataset.qty})`;
      if (summary.textContent !== next) summary.textContent = next;

      setSubmitState(form);
    }

    // ─── Quantity buttons ────────────────────────────────────────────────────────

    function initQtyButtons(form) {
      form.querySelectorAll('.quantity-control').forEach((wrapper) => {
        const input = wrapper.querySelector('[data-quick-order-quantity]');
        const incBtn = wrapper.querySelector('.quanity_increment');
        const decBtn = wrapper.querySelector('.quanity_descrement');
        if (!input) return;

        function step(delta) {
          if (input.disabled) return;
          let val = parseInt(input.value, 10) || 1;
          const max = parseInt(input.max, 10);
          if (delta > 0 && !isNaN(max) && val >= max) {
          const row = input.closest('[data-quick-order-row]');
          if (row) {
            showRowError(row, `Only ${max} item${max > 1 ? 's are' : ' is'} available.`);
          }
          return;
        }
          if (delta < 0 && val <= 1) return;
          val += delta;

          const row = input.closest('[data-quick-order-row]');
          row ? syncQtyInputs(row, val) : (input.value = val);
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Click
        incBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          step(1);
        });
        decBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          step(-1);
        });

        // Keyboard (Enter / Space) — accessibility
        [incBtn, decBtn].forEach((btn) => {
          if (!btn) return;
          btn.setAttribute('role', 'button');
          btn.setAttribute('tabindex', '0');
          btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              step(btn.classList.contains('quanity_increment') ? 1 : -1);
            }
          });
        });
      });
    }

    // ─── Variant select ──────────────────────────────────────────────────────────

    function initVariantSelects(form) {
      form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
        const select = row.querySelector('[data-quick-order-variant-select]');
        if (!select) return;

        select.addEventListener('change', () => {
          const opt = select.options[select.selectedIndex];
          const variantId = opt.value;
          const available = opt.dataset.available === 'true';

          // Update variant ID on every qty input in this row
          row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
            input.dataset.quickOrderVariantId = variantId;
          });

          // Update price display
          const priceEl = row.querySelector('[data-quick-order-price]');

          if (priceEl) {
            const sale = priceEl.querySelector('.price-sale, .price');
            const compare = priceEl.querySelector('.price-compare');

            if (sale) {
              sale.textContent = opt.dataset.price;
            }

            if (compare) {
              if (opt.dataset.comparePrice) {
                compare.textContent = opt.dataset.comparePrice;
                compare.style.display = '';
              } else {
                compare.style.display = 'none';
              }
            }
          }

          setRowAvailability(row, available);
          updateSummary(form);
        });
      });
    }


    function clearRowError(row) {
        const el = row.querySelector('[data-quick-order-row-error]');
        if (!el) return;

        el.classList.add('d-none');
        el.innerHTML = '';
      }

      function showRowError(row, message) {
        const el = row.querySelector('[data-quick-order-row-error]');
        if (!el) return;

        el.innerHTML = `
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#dc2626" aria-hidden="true">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10.0586 6.05547C10.0268 5.48227 10.483 5 11.0571 5H12.9429C13.517 5 13.9732 5.48227 13.9414 6.05547L13.5525 13.0555C13.523 13.5854 13.0847 14 12.554 14H11.446C10.9153 14 10.477 13.5854 10.4475 13.0555L10.0586 6.05547ZM14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17Z"/>
          </svg>
          <span>${message}</span>
        `;

        el.classList.remove('d-none');

        setTimeout(() => {
          clearRowError(row);
        }, 3000);
      }

    // ─── Form submit ─────────────────────────────────────────────────────────────

    function initSubmit(form) {
      const submitBtn = form.querySelector('[data-quick-order-submit]');
      const statusEl = form.querySelector('[data-quick-order-status]');
      const submitLabel = form.dataset.quickOrderSubmitLabel || submitBtn?.textContent || 'Add to cart';
      const errorMsg = form.dataset.quickOrderGenericErrorMessage || 'Something went wrong.';

      form.querySelectorAll('[data-quick-order-row]').forEach(clearRowError);

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const items = [];
        const addedRows = [];

        form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
          const checkbox = row.querySelector('[data-quick-order-checkbox]');
          const input = getVisibleQtyInput(row);
          if (!checkbox?.checked || !input || input.disabled) return;

          const variantId = Number(input.dataset.quickOrderVariantId);
          const quantity = parseInt(input.value, 10) || 1;
          if (!variantId) return;

          items.push({ id: variantId, quantity });
          addedRows.push(row);
        });

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!res.ok) {
            // Ignore Shopify quantity limit error
            try {
              const d = await res.json();
              const message = d.description || d.message || errorMsg;

              if (message.toLowerCase().includes('maximum quantity')) {
                const match = message.match(/id\s+(\d+)/i);

                if (match) {
                  const variantId = match[1];

                  const row = [...form.querySelectorAll('[data-quick-order-row]')]
                    .find(r =>
                      r.querySelector(
                        `[data-quick-order-quantity][data-quick-order-variant-id="${variantId}"]`
                      )
                    );

                  if (row) {
                    showRowError(row, message);
                    return;
                  }
                }
              }

              showStatus(form, message);
            } catch (_) {
              showStatus(form, errorMsg);
            }

            return;
          }

          // Reset rows
          addedRows.forEach((row) => {
            syncQtyInputs(row, 1);
            const cb = row.querySelector('[data-quick-order-checkbox]');
            if (cb) cb.checked = false;
            row.classList.remove('quick-order__row--added');
            void row.offsetWidth;
            row.classList.add('quick-order__row--added');
          });

          updateSummary(form);

          // ── Update cart count badge in header ──────────────────────────
          try {
            const cartRes = await fetch('/cart.js', { cache: 'no-store' });
            const cartData = await cartRes.json();
            const count = cartData.item_count;

            // Covers the most common badge selectors across themes
            document
              .querySelectorAll(
                [
                  '.cart-count',
                  '.cart-item-count',
                  '.cart__count',
                  '[data-cart-count]',
                  '[data-cart-item-count]',
                  '.open-cart-drawer a > span:last-child',
                  '#cart-count',
                  '.header__cart-count',
                ].join(',')
              )
              .forEach((el) => {
                el.textContent = count;
                // Some themes hide the badge when 0 and show it when >0
                if (count > 0) {
                  el.removeAttribute('hidden');
                  el.classList.remove('d-none', 'hidden', 'is-hidden');
                }
              });

            // Bubble up for any theme-level cart:refresh listeners
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
          } catch (_) {}
          // ────────────────────────────────────────────────────────────────

          document.dispatchEvent(new CustomEvent('quick-order:items-added', { detail: { items } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          const cartType = form.dataset.cartType;

            if (cartType === 'page') {
              window.location.href = '/cart';
              return;
            }
          // Open drawer or redirect
          const cartDrawer = document.getElementById('cartOffCanvas');
          if (cartDrawer && window.bootstrap?.Offcanvas) {
            (bootstrap.Offcanvas.getInstance(cartDrawer) || new bootstrap.Offcanvas(cartDrawer)).show();
          }
        } catch (_) {
          showStatus(form, errorMsg);
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          }
        }
      });
    }

    // ─── Status helpers ───────────────────────────────────────────────────────────

   let statusTimeout;

      function showStatus(form, message, isError = true) {
        let el = form.querySelector('[data-quick-order-status]');

        if (!el) {
          el = document.createElement('p');
          el.dataset.quickOrderStatus = '';
          el.className = 'quick-order__status mt-2 text-center d-flex align-items-center justify-content-center gap-2';
          form.querySelector('.quick-order__actions')?.after(el);
        }

        clearTimeout(statusTimeout);

        if (isError) {
          el.innerHTML = `
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#dc3545" aria-hidden="true" style="flex:0 0 auto;">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10.0586 6.05547C10.0268 5.48227 10.483 5 11.0571 5H12.9429C13.517 5 13.9732 5.48227 13.9414 6.05547L13.5525 13.0555C13.523 13.5854 13.0847 14 12.554 14H11.446C10.9153 14 10.477 13.5854 10.4475 13.0555L10.0586 6.05547ZM14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17Z"
                fill="#dc3545">
              </path>
            </svg>
            <span>${message}</span>
          `;
        } else {
          el.textContent = message;
        }

        el.removeAttribute('hidden');
        el.classList.remove('d-none');

        statusTimeout = setTimeout(() => {
          el.classList.add('d-none');
          el.innerHTML = '';
        }, 3000);
      }

    function hideStatus(form) {
      const el = form.querySelector('[data-quick-order-status]');
      if (el) {
        el.textContent = '';
        el.classList.add('d-none');
      }
    }

    // ─── Boot ─────────────────────────────────────────────────────────────────────

    function bootForm(form) {
      // Prevent double-initialization
      if (form.dataset.quickOrderBooted === 'true') return;
      form.dataset.quickOrderBooted = 'true';

      // Checkbox → summary
      form.querySelectorAll('[data-quick-order-checkbox]').forEach((cb) => {
        cb.addEventListener('change', () => updateSummary(form));
      });

      // Qty input → summary (debounced)
      let tid;
      form.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
        input.addEventListener('input', () => {
          const row = input.closest('[data-quick-order-row]');
          const max = parseInt(input.max, 10);
          let value = parseInt(input.value, 10) || 1;

          if (!isNaN(max) && value > max) {
            value = max;
            syncQtyInputs(row, value);

            showRowError(
              row,
              `Only ${max} item${max > 1 ? 's are' : ' is'} available.`
            );
          } else {
            syncQtyInputs(row, value);
            clearRowError(row);
          }

          clearTimeout(tid);
          tid = setTimeout(() => updateSummary(form), 150);
        });
      });

      initQtyButtons(form);
      initVariantSelects(form);
      initSubmit(form);
      updateSummary(form);
    }

    function bootAll() {
      document.querySelectorAll('[data-quick-order-form]').forEach(bootForm);
    }

    // Initial boot
    bootAll();

    // Shopify theme customizer events
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        // Section was reloaded — clear the boot flag so it re-initializes cleanly
        const form = e.target?.querySelector('[data-quick-order-form]');
        if (form) {
          delete form.dataset.quickOrderBooted;
          setTimeout(() => bootForm(form), 150);
        }
      });
      document.addEventListener('shopify:section:reorder', () => {
        setTimeout(bootAll, 150);
      });
      document.addEventListener('shopify:section:select', (e) => {
        const form = e.target?.querySelector('[data-quick-order-form]');
        if (form) setTimeout(() => updateSummary(form), 150);
      });
    }

    // Fallback for late DOM
    document.addEventListener('DOMContentLoaded', bootAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playVisibleVideos() {
      var videos = document.querySelectorAll('.video-grid video');
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      videos.forEach(function (video) {
        var rect = video.getBoundingClientRect();
        var height = rect.bottom - rect.top;
        var visible = rect.top < viewportHeight * 0.7 && rect.bottom > viewportHeight * 0.3 && height > 0;

        if (visible) {
          video.muted = true;
          video.autoplay = true;
          video.playsInline = true;

          if (video.paused) {
            video.play().catch(function () {});
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', playVisibleVideos);
    } else {
      playVisibleVideos();
    }

    var scrollTimer;
    window.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(playVisibleVideos, 100);
      },
      { passive: true }
    );

    window.addEventListener('resize', playVisibleVideos);
  })();

  } catch(e) { console.error(e); }
})();
})();
